/*
  SHOP の絞り込みと並べ替えの補助。

  - 並べ替え: 選んだらすぐ反映する。
    JavaScript が無効でも <noscript> の［並べ替える］ボタンで送信できる。
  - 狭い画面では絞り込みの各グループを畳んでおく（読み込み時に1回だけ）。
    JavaScript が無効なときは開いたままなので、操作できなくなることはない。
*/
(function () {
  'use strict';

  var MOBILE_MAX = 989;

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('[data-tr-sort]')) return;

    var form = select.form;
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  function collapseOnMobile() {
    if (window.innerWidth > MOBILE_MAX) return;

    var groups = document.querySelectorAll('.tr-sh__group[open]');
    for (var i = 0; i < groups.length; i += 1) {
      // 絞り込みが効いているグループは開いたままにする
      if (groups[i].querySelector('.tr-sh__opt.is-active')) continue;
      groups[i].removeAttribute('open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseOnMobile, { once: true });
  } else {
    collapseOnMobile();
  }
})();
